// extracted by mini-css-extract-plugin
module.exports = {"root":"MigrateLegal_root__lskTn","one":"MigrateLegal_one__p9SLR","two":"MigrateLegal_two__9QOC_"};